export default "__VITE_ASSET__CELbRwVp__"